/* eslint-disable */
import { useState } from "react";
import { useEffect } from "react";
import ReactPlayer from 'react-player/lazy';
// import PdfViewer from "components/pdf/PdfViewer"
import { fileAccepts } from 'data/data';
import CCTVWebRTCViewer from "./CCTVWebRTCViewer";
import SafeImage from "./SafeImage";

const FileViewerByFileUrl = ({fileUrl, extension, sampleImgSrc=`${process.env.PUBLIC_URL}/img/sample.png`, status=null, muted=false, selectedStream=null}) => {
    const [accept, setAccept] = useState(null);
    
    useEffect(()=>{
        // console.log(fileUrl)
        if (fileUrl) {
            setAccept(fileAccepts.filter(acc => acc.extension.indexOf(extension) !== -1)[0]);
        }
    },[fileUrl, extension]);
// console.log(stream)
    if (selectedStream) {
        return (
            <CCTVWebRTCViewer selectedStream={selectedStream} />
        )
    }

    if (fileUrl && accept && accept.code === 'I') {
        return (
            // <img src={fileUrl} style={{width:"100%"}} alt="image" />
            <SafeImage
                src={fileUrl}
                style={{width:"100%"}}
                alt="image"
                fallback={sampleImgSrc}
            />
        )
    }

    if (fileUrl && accept && accept.code === 'M') {
        return (
            <div className='player-wrapper' style={{width:'98%', margin:"auto"}}>
                <ReactPlayer
                    className='react-player'
                    url={fileUrl}
                    width='99%'
                    height='99%'
                    playing={status?.toLowerCase() === 'stop' ? false:true}
                    loop={true}
                    muted={muted}
                />
            </div>
        )
    }
    return null; // 아무 조건도 맞지 않을 때
}

export default FileViewerByFileUrl;